// extracted by mini-css-extract-plugin
module.exports = {"container":"RecalculationAccounts_container_1E_L5","text":"RecalculationAccounts_text_AuaUL","button":"RecalculationAccounts_button_3NxZ0"};